import React from 'react';
import { styled } from '@linaria/react';
import { animated } from 'react-spring';
import { ChevronDown } from 'lucide-react';

import useBoop from '@/hooks/use-boop';

import ShiftBy from '@/components/ShiftBy';
import Spacer from '@/components/Spacer';

function ShowMoreDemo() {
  const [hasClicked, setHasClicked] = React.useState(false);
  const [style, trigger] = useBoop({ y: 3 });

  return (
    <Wrapper>
      <Button
        onMouseEnter={trigger}
        onClick={() => {
          setHasClicked(true);
          trigger();
        }}
      >
        Show more
        <Spacer size={8} />
        <ShiftBy y={6}>
          <IconWrapper style={style}>
            <ChevronDown size={32} />
          </IconWrapper>
        </ShiftBy>
      </Button>

      {hasClicked && (
        <Disclaimer>
          (Nothing to see here, it's just a hover demo!)
        </Disclaimer>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 48px;
`;

const Button = styled.button`
  display: flex;
  font-size: 24px;
  font-weight: var(--font-weight-medium);
  padding: 4px 8px 4px 16px;
  border-radius: 8px;
  background: var(--color-gray-100);
  color: var(--color-text);
`;

const IconWrapper = styled(animated.span)`
  display: inline-block;

  i,
  svg {
    display: block !important;
  }
`;
const Disclaimer = styled.p`
  margin-top: 16px;
  text-align: center;
  font-size: 1rem;
  color: var(--color-gray-700);
`;

export default ShowMoreDemo;
